import React, { FunctionComponent } from 'react';
import { DataCategory, DataValueRecruitmentShowContent } from '../../../types/recruitmentShow';
import { RecruitmentShowContentFollowSliderTop } from '../../molecules/recruitmentShowContentFollowSliderTop';
import { RecruitmentShowContentFollowSliderMiddle } from '../../molecules/recruitmentShowContentFollowSliderMiddle';
import { RecruitmentShowApplicationsBrands } from '../../molecules/recruitmentShowApplicationsBrands';

type Props = {
  noimage: string;
  companyId: number;
  recruitmentId: number;
  isStopped: boolean;
  occupationUrl?: string;
  occupationName?: string;
  industryUrl?: string;
  target: 'recruitments';
  dataCategory: DataCategory;
  dataValue: DataValueRecruitmentShowContent;
  isPreview: boolean;
};

export const Presentation: FunctionComponent<Props> = ({
  noimage,
  companyId,
  recruitmentId,
  isStopped,
  occupationUrl,
  occupationName,
  industryUrl,
  target,
  dataCategory,
  dataValue,
  isPreview,
}) => {
  return (
    <div className="recruitment__show__wrapper__follow__slider">
      <RecruitmentShowApplicationsBrands
        title='このブランドの募集中求人'
        noimage={noimage}
        recruitmentId={recruitmentId}
        isStopped={isStopped}
        dataCategory={dataCategory}
        dataValue={dataValue}
        isPreview={isPreview}
      />
      <RecruitmentShowContentFollowSliderTop
        title='この企業の募集中求人'
        noimage={noimage}
        companyId={companyId}
        recruitmentId={recruitmentId}
        isStopped={isStopped}
        target='recruitments'
        dataCategory={dataCategory.stopRecruitmentContent}
        dataValue={dataValue}
      />
      <RecruitmentShowContentFollowSliderMiddle
        occupationUrl={occupationUrl}
        occupationName={occupationName}
        noimage={noimage}
        recruitmentId={recruitmentId}
        isStopped={isStopped}
        dataCategory={dataCategory.stopRecruitmentContent}
        dataValue={dataValue}
      />
    </div>
  );
};
